import { Navigate, Outlet } from 'react-router-dom';
import { ReactNode } from "react";

interface IPrivateRoutesProps {
    autenticado: boolean;
    layout?: ReactNode;
}

const PrivateRoutes = ({ autenticado }: IPrivateRoutesProps) => {
    if (!autenticado) {
        return <Navigate to="/login" replace />;
    }
    
    return <Outlet />;
};

export default PrivateRoutes;
